var _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCmdOpen24(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "aw-theme-iconOutline",
    fill: "#464646",
    points: "18,24 0,24 0,6 6,6 6,7 1,7 1,23 17,23 17,15 18,15  "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "aw-theme-iconOutline",
    fill: "#464646",
    d: "M17.4,0.6l-0.7,0.7L21.3,6H14c-3.9,0-7,3.1-7,7c0,2.8,1.7,5.4,4.3,6.5l0.4-0.9C9.4,17.6,8,15.4,8,13 c0-3.3,2.7-6,6-6h7.3l-4.6,4.6l0.7,0.7l5.9-5.9L17.4,0.6z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCmdOpen24);
export default __webpack_public_path__ + "static/media/cmdOpen24.6cc46157ec5009c91059def0b8cb11cf.svg";
export { ForwardRef as ReactComponent };